import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, IconButton } from "@mui/material";
import { Close as CloseIcon, PlayCircleOutline as VideoIcon, Link as LinkIcon } from "@mui/icons-material";
import PropTypes from "prop-types";
import theme from "../../theme";

const ChecklistHelpModal = ({ open, onClose, helpContent }) => {
  if (!helpContent) return null;

  const { text, videoUrl, linkUrl, linkText } = helpContent;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: "8px",
        },
      }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
          How to Complete This Step
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        {/* Help Text */}
        {text && (
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6, color: theme.palette.text.primary }}>
            {text}
          </Typography>
        )}

        {/* Video Embed */}
        {videoUrl && (
          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <VideoIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Video Tutorial
              </Typography>
            </Box>
            <Box
              sx={{
                position: "relative",
                paddingBottom: "56.25%", // 16:9 aspect ratio
                height: 0,
                overflow: "hidden",
                borderRadius: "8px",
                backgroundColor: "#000",
                "& iframe": {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                },
              }}
            >
              <iframe
                src={videoUrl}
                title="Help Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </Box>
          </Box>
        )}

        {/* Documentation Link */}
        {linkUrl && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              p: 2,
              borderRadius: "8px",
              backgroundColor: theme.palette.grey[100],
              cursor: "pointer",
              transition: "background-color 0.2s",
              "&:hover": {
                backgroundColor: theme.palette.grey[200],
              },
            }}
            onClick={() => window.open(linkUrl, "_blank")}
          >
            <LinkIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
            <Typography variant="body2" sx={{ color: theme.palette.primary.main, fontWeight: 500 }}>
              {linkText || "View Documentation"}
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="contained" sx={{ borderRadius: "8px", textTransform: "none", px: 3 }}>
          Got It
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ChecklistHelpModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  helpContent: PropTypes.shape({
    text: PropTypes.string,
    videoUrl: PropTypes.string,
    linkUrl: PropTypes.string,
    linkText: PropTypes.string,
  }),
};

export default ChecklistHelpModal;
